import { Buffer } from 'buffer';
export const encryptor = async (string) => {
    try {
        const publicKey = await window.crypto.subtle.importKey(
            'spki',
            new Uint8Array(atob(process.env.REACT_APP_publicKey).split('').map(char => char.charCodeAt(0))),
            {
                name: "RSA-OAEP",
                hash: { name: "SHA-256" },
            },
            true,
            ["encrypt"]
        )
        const encrypted = await window.crypto.subtle.encrypt(
            "RSA-OAEP",
            publicKey,
            Buffer.from(string, 'utf-8')
            // encoder.encode(string)
        )
        const base64 = Buffer.from(encrypted, 'base64').toString('base64') //btoa(String.fromCharCode(...new Uint8Array(encrypted)));
        return base64
    } catch (error) {
        console.error(error);
        return null
    }
}

export const getSymmetricKey = async () => {
    const key = await window.crypto.subtle.generateKey(
        {
            name: 'AES-GCM',
            length: 256,
        },
        true,
        ['encrypt', 'decrypt']
    )
    const a = await window.crypto.subtle.exportKey('raw', key)
    return { key: key, exportKey: Buffer.from(a, 'utf-8').toString('base64') }
}